import { useEffect, useState } from 'react';
import { Checkbox, Modal, Typography } from 'antd';
import { useParams } from 'react-router';

import SectionMessage from 'components/SectionMessage/SectionMessage';
import useAccountQuery from 'hooks/useAccountQuery';
import useModalControls from 'hooks/useModalControls';

const { Paragraph } = Typography;

export const useBankruptcyBoundaryModal = (onAcknowledged = () => {}) => {
  const { accountId, customerId } = useParams();
  const { accountInBankruptcy } = useAccountQuery(customerId, accountId);
  const bankruptcyBoundaryModal = useModalControls();
  const [bankruptcyDismissed, setBankruptcyDismissed] = useState(false);

  const checkBankruptcyBoundary = () => {
    if (accountInBankruptcy && !bankruptcyDismissed) {
      bankruptcyBoundaryModal.show();
    } else {
      onAcknowledged();
    }
  };

  const onBankruptcyAcknowledged = () => {
    setBankruptcyDismissed(true);
    onAcknowledged();
  };

  useEffect(() => {
    setBankruptcyDismissed(false);
  }, [customerId, accountId]);

  return {
    bankruptcyBoundaryModal,
    checkBankruptcyBoundary,
    onBankruptcyAcknowledged,
  };
};

const BankruptcyBoundaryModal = ({
  account,
  onBankruptcyAcknowledged = () => {},
  hide,
  show,
  ...modalProps
}) => {
  const { accountId } = useParams();
  const [acknowledged, setAcknowledged] = useState(false);
  const [showValidation, setShowValidation] = useState(false);

  const handleSubmit = async () => {
    if (acknowledged) {
      setShowValidation(false);
      onBankruptcyAcknowledged();
      hide();
    } else {
      setShowValidation(true);
    }
  };

  useEffect(() => {
    setAcknowledged(false);
    setShowValidation(false);
  }, [accountId]);

  return (
    <Modal
      {...modalProps}
      title="Bankruptcy"
      width={800}
      onCancel={hide}
      onOk={handleSubmit}
      okText="Continue"
      okButtonProps={{ 'data-testid': 'continue-button' }}
    >
      <div style={{ textAlign: 'center', marginBottom: 'var(--spacing-lg)' }}>
        <SectionMessage
          size="medium"
          status="warning"
          text="This account is marked as bankrupt"
          body={
            <>
              {/* May need to make this message configurable if this modal is used for not involving payments */}
              <Paragraph>
                We do not accept any form of payments on a bankruptcy account.{' '}
                <br />
                In order to proceed, you must confirm that the bankruptcy has
                been dismissed for this account.
              </Paragraph>
              <Checkbox
                data-testid="acknowledge-bankruptcy-checkbox"
                checked={acknowledged}
                onChange={(event) => setAcknowledged(event.target.checked)}
              >
                I have confirmed the bankruptcy for this account has been
                dismissed.
              </Checkbox>
              {showValidation ? (
                <Typography.Text type="danger">
                  Please confirm bankruptcy has been dismissed
                </Typography.Text>
              ) : null}
            </>
          }
        />
      </div>
    </Modal>
  );
};

export default BankruptcyBoundaryModal;
